import DeliveryHasCancellation from "../symbols/deliveryHasCancellation";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function DeliveryHasCancellationReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case DeliveryHasCancellation.DELIVERY_HAS_CANCELLATION:
      return { ...state, loading: true, error: false };
    case DeliveryHasCancellation.DELIVERY_HAS_CANCELLATION_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case DeliveryHasCancellation.DELIVERY_HAS_CANCELLATION_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case DeliveryHasCancellation.CLEAR_DELIVERY_HAS_CANCELLATION:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
